import _ from 'underscore';
import { ColumnNameToFluctuationTypeEnum } from './fluctuations/index';

/** Generate help id for columns
 * @param {string} name column name
 * @param {function|string} helpId help id function or string
 * @returns {string} generated help id
 */
export const generateHelpId = ({ name, helpId }) => {
  if (_.isFunction(helpId)) {
    return helpId(name);
  }
  // String help ID
  if (_.isString(helpId)) {
    return helpId;
  }
  // No help ID
  if (_.isNull(helpId)) {
    return null;
  }
  // Default performance metrics help ID
  return `Page_CampaignGrids_${name}`;
};

/**
 * Check if performance metric has fluctuation insights or not
 * @param {string} propertyName The property name in column's config
 * @param {List} availableInsightTypeIds List of insight type enums for the account/campaign
 * @returns {bool} If there's insight for this metric or not
 */
export const hasFluctuations = ({
  propertyName,
  availableInsightTypeIds,
} = {}) => {
  if (!_.isEmpty(propertyName) && availableInsightTypeIds) {
    return _.contains(
      availableInsightTypeIds,
      ColumnNameToFluctuationTypeEnum[propertyName]
    );
  }
  return false;
};

/**
 * Format metric value number to string in columns with fluctuation insights
 * @param {object} i18n i18n
 * @param {string} format The format of metric value
 * @param {number} metricValue Metric value
 * @returns {string} formated value
 */
export const formatMetricValue = ({ i18n, format, metricValue }) => {
  if (_.isUndefined(metricValue) || _.isNull(metricValue)) {
    return null;
  }
  const fractionDigits = format === 'decimal' ? 2 : 0;
  const formattedMetricValue = i18n.formatDecimal(
    metricValue,
    { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits }
  );
  return formattedMetricValue;
};
